import { render, staticRenderFns } from "./BaseDateCommon.vue?vue&type=template&id=526b7bb0&scoped=true"
import script from "./BaseDateCommon.vue?vue&type=script&lang=js"
export * from "./BaseDateCommon.vue?vue&type=script&lang=js"
import style0 from "./BaseDateCommon.vue?vue&type=style&index=0&id=526b7bb0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526b7bb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('526b7bb0')) {
      api.createRecord('526b7bb0', component.options)
    } else {
      api.reload('526b7bb0', component.options)
    }
    module.hot.accept("./BaseDateCommon.vue?vue&type=template&id=526b7bb0&scoped=true", function () {
      api.rerender('526b7bb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/BaseDateCommon.vue"
export default component.exports